/**
 * 应用提示钩子，目前可能有两个提示:
 * 1. 版本更新提示，针对存量用户，对应 userConfig 是 update_version, 0 为需要提示， 1 为已经提示过
 * 2. 地区禁用提示，针对所有用户，对应 userConfig 是 region_ban, 1 为需要提示， 0 为不需要提示
 *
 * 当上面两者都需要提示的时候，提示地区禁用，不提示版本更新
 */
import { openRegionBanModal } from '@/components/region-ban-modal';
import { openUpdateVersionModal } from '@/components/update-version-modal';
import { useUserInfoContext } from '@/contexts/user-info-context';
import {
  getUserConfigFromTargetSpace,
  updateUserConfigFromTargetSpace,
} from '@/services/user';
import { useEffect } from 'react';

const useAppNotice = () => {
  const { userInfo } = useUserInfoContext();
  const userId = userInfo?.user_id;
  const isHistoryUser = userInfo?.history_user_flag;

  useEffect(() => {
    if (!userId) {
      return;
    }
    (async () => {
      const userConfig = await getUserConfigFromTargetSpace({
        keys: ['update_version', 'region_ban'],
      });
      const showUpdateVersion =
        isHistoryUser && !Number(userConfig.update_version);
      const showRegionBan = !!Number(userConfig.region_ban);
      if (showRegionBan) {
        openRegionBanModal();
        await updateUserConfigFromTargetSpace({
          key: 'region_ban',
          value: '0',
        });
        await updateUserConfigFromTargetSpace({
          key: 'update_version',
          value: '1',
        });
        return;
      }

      if (showUpdateVersion) {
        openUpdateVersionModal();
        await updateUserConfigFromTargetSpace({
          key: 'update_version',
          value: '1',
        });
      }
    })();
  }, [userId, isHistoryUser]);
};

export default useAppNotice;
